import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDragDrop, CdkDrag, CdkDropList, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ItemService } from '../item/item.service';
import { HttpParams } from '@angular/common/http';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';
import { MinusSquareTwoTone, MinusOutline, DownCircleTwoTone, DownOutline, UpCircleTwoTone, UpOutline } from '@ant-design/icons-angular/icons';

@Component({
  selector: 'app-market-price',
  imports: [NzIconModule, CommonModule, CdkDropList, CdkDrag, NzCardModule, NzButtonModule, DragDropModule],
  providers: [
      // Register the icons
      { provide: NZ_ICONS, useValue: [MinusSquareTwoTone, MinusOutline, DownCircleTwoTone, DownOutline, UpOutline, UpCircleTwoTone] },
    ],
  templateUrl: './market-price.component.html',
  styleUrl: './market-price.component.scss'
})
export class MarketPriceComponent implements OnInit {

  filterItems: Array<any> = [];
  // Selected items will store objects with item name and price
  selectedItems: { name: string; price: number, id: string; status: number }[] = [{ name: 'Laptop', price: 2000, id: "1", status: 1 }, { name: 'Phone', price: 500, id: "2", status: 2 }];
  groupedItems: { [key: string]: any[] } = {};
  filtergroupedItems: { [key: string]: any[] } = {};
  items: any[];

  constructor(private itemService: ItemService) {

  }


  ngOnInit(): void {
    let params = new HttpParams()
      .set('page', "-1")
      .set('pageSize', "-1");
    this.itemService.getItems(params).subscribe({
      next: x => {
        this.items = x.data;
        console.log(this.items);
      },
      error: err => { },
      complete: () => {
        this.filterItems = this.items.filter(item =>
          !this.selectedItems.some(compareItem =>
            item.id === compareItem.id && item.price === compareItem.price
          )
        );
      }
    });



    // this.filterItems = this.items.filter(item =>
    //   !this.selectedItems.some(compareItem =>
    //     item.name === compareItem.name && item.price === compareItem.price
    //   )
    // );
  }





  // Handles drop event and pairs item with price
  drop(event: CdkDragDrop<any>) {
    const item = this.filterItems[event.previousIndex];
    console.log(item);
    this.filterItems.splice(event.previousIndex, 1);
    this.selectedItems.push(item);
  }

  // Remove item from the selected list
  removeItem(index: number) {
    const removedItem = this.selectedItems.splice(index, 1)[0];
    const isOccured = this.items.some(compareItem =>
      removedItem.name === compareItem.name && removedItem.price === compareItem.price
    )
    if (isOccured) {
      this.filterItems.push(removedItem);
    }
  }

  isStringArray(value: unknown): value is string[] {
    return Array.isArray(value) && value.every(item => typeof item === 'string');
  }

  // groupItemsByCategory() {
  //   this.groupedItems = this.items.reduce((acc, item) => {
  //     acc[item.category] = acc[item.category] || [];
  //     acc[item.category].push(item);
  //     return acc;
  //   }, {} as { [key: string]: any[] });
  // }

  publishPrices() {

  }
}
